export default __webpack_public_path__ + "d2437efdfe4296709a44dceced988b91.svg";